<mat-dialog-content class="adap-dialog-content">
  <app-dialog-header [title]="title"></app-dialog-header>
  <ng-container *ngIf="formState$ | async as formState">
    <form
      #form
      novalidate
      [ngrxFormState]="formState"
      class="adap-form-container"
    >
      <div class="form-row-2-columns">
        <app-input-container
          label="title"
          [app-input-validation-container]="formState.controls.title!"
          [isRequired]="true"
        >
          <input
            class="adap-form-input"
            [ngrxFormControlState]="formState.controls.title!"
            placeholder="title"
          />
        </app-input-container>
        <div class="checkbox-container">
          <div class="section-input">
            <mat-checkbox
              color="primary"
              [ngrxFormControlState]="formState.controls.hideIfOnShore!"
            >
              hide if onshore
            </mat-checkbox>
          </div>
          <div class="section-input">
            <mat-checkbox
              color="primary"
              [ngrxFormControlState]="formState.controls.hideIfOffShore!"
            >
              hide if offshore
            </mat-checkbox>
          </div>
        </div>
        <app-input-container
          label="phase 2B definition"
          [app-input-validation-container]="
            formState.controls.phase2BDefinition
          "
        >
          <textarea
            class="adap-form-textarea adap-form-input"
            [ngrxFormControlState]="formState.controls.phase2BDefinition"
            placeholder="phase 2B definition"
          ></textarea>
        </app-input-container>
        <app-input-container
          label="phase 2C definition"
          [app-input-validation-container]="
            formState.controls.phase2CDefinition
          "
        >
          <textarea
            class="adap-form-textarea adap-form-input"
            [ngrxFormControlState]="formState.controls.phase2CDefinition"
            placeholder="phase 2C definition"
          ></textarea>
        </app-input-container>
        <app-input-container
          label="phase 3 definition"
          [app-input-validation-container]="formState.controls.phase3Definition"
        >
          <textarea
            class="adap-form-textarea adap-form-input"
            [ngrxFormControlState]="formState.controls.phase3Definition"
            placeholder="phase 3 definition"
          ></textarea>
        </app-input-container>
        <app-input-container
          label="phase 4 definition"
          [app-input-validation-container]="formState.controls.phase4Definition"
        >
          <textarea
            class="adap-form-textarea adap-form-input"
            [ngrxFormControlState]="formState.controls.phase4Definition"
            placeholder="phase 4 definition"
          ></textarea>
        </app-input-container>
      </div>
    </form>
    <div class="dialog-actions">
      <button class="adap-btn-outline" type="button" (click)="closeWindow()">
        cancel
      </button>
      <ng-container>
        <ng-container>
          <button
            class="adap-btn-filled"
            type="button"
            [disabled]="!formState.isValid"
            (click)="save()"
          >
            save
          </button>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</mat-dialog-content>
